import { ActivityItem } from '@cube3/cubicle/src/core/molecules/Activity/ActivityItem';
import React from 'react';
import { useAssetActivityFeed } from '../hooks/useAssetActivityFeed';
import { Activity } from '@cube3/common/model/schema/resources/activities';
import { DataSectionApproval } from '@cube3/cubicle/src/core/atoms/Activity/DataSectionApproval';
import { DataSectionComment } from '@cube3/cubicle/src/core/atoms/Activity/DataSectionComment';
import { SHARE_ACTIONS } from '@cube3/common/model/types/activity-types';

export interface ActivityItemProps {
  activity: Activity;
  onClose?: () => void;
}

export const AssetActivityItem = (props: ActivityItemProps) => {
  const { activity, onClose } = props;

  const { subject } = activity.relationships;

  const {
    imageSection,
    topRowSection,
    bottomRowSection,
    subjectResource,
    resolvedComment,
    onDefaultClick,
    onClickDataSection
  } = useAssetActivityFeed(activity, onClose);

  const oldValue = activity?.['oldValue'];

  const isComment = subject?.type === 'comment';
  const isApproval = subject?.type === 'approval';

  const isResolvedAction = isComment && !!subjectResource?.resolution;
  const commentMessage =
    oldValue ||
    (isResolvedAction ? resolvedComment?.message : subjectResource?.message);

  return (
    <ActivityItem
      fullWidth={true}
      imageSection={imageSection}
      topRowSection={topRowSection}
      bottomRowSection={bottomRowSection}
      onDefaultClick={onDefaultClick}
      dataSection={
        isComment ? (
          commentMessage ? (
            <DataSectionComment
              onClick={onClickDataSection}
              withSvg={!!subjectResource?.drawing_svg}
              message={commentMessage}
            />
          ) : activity.action === SHARE_ACTIONS.CommentDeleted ? null : (
            <DataSectionComment message={'This comment was deleted'} />
          )
        ) : isApproval ? (
          subjectResource?.status ? (
            <DataSectionApproval
              onClick={onClickDataSection}
              status={oldValue || subjectResource.status}
            />
          ) : null
        ) : null
      }
    />
  );
};
